
module.exports = {
  isJSON: function(str) {
    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            console.log('转换成功：'+obj);
            return true;
        } catch(e) {
            console.log('error：'+str+'!!!'+e);
            return false;
        }
    }
  }　
}


//////////////////
// WEBPACK FOOTER
// ./src/utiles/judge.js
// module id = 26
// module chunks = 0